import http from "./core";
import signalr from "./signalr";

export const appointmentsServer = {
  getAll() {
    return http.get(`api/portal/Appointments`);
  },
  createAppointmentRequest(data) {
    return http.put(`api/portal/AppointmentRequests`, data);
  },
  cancelAppointment(id) {
    return http.get(`api/portal/AppointmentRequests/cancel/${id}`);
  },
  async getServiceDates(data) {
    const result = await http.post(
      `api/portal/AppointmentRequests/Dates`,
      data
    );
    return result.data;
  },
  async getServiceHours(data) {
    const result = await http.post(
      `api/portal/AppointmentRequests/Hours`,
      data
    );
    return result.data;
  },
  getAppointmentRequests(id) {
    return http.get(`api/portal/AppointmentRequests/` + id);
  },
  getFirstAvailableLocation() {
    return http.get(`api/portal/AppointmentRequests/GetAnyAvailableLocation`);
  },
  getFirstAvailablePlaceOfService() {
    return http.get(
      `api/portal/AppointmentRequests/GetAnyAvailablePlaceOfService`
    );
  },
  sendToMainApp(tenantName, scheduleEventId, signalrAppUrl) {
    return signalr.post(
      `${signalrAppUrl}/api/signalr/appointments/SendAppointmentUpdateSignalToMainApp/${tenantName}/${scheduleEventId}`
    );
  }
};
